"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

const MOBILE_VIEWPORT_WIDTH = 1210;

interface CourseTabProps {
    prefix: string
}

const AdmissionTab = () => {
    const [isDropDown, setIsDropDown] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    const [isDesktop, setIsDesktop] =
        useState<
            boolean>
            (() => {
                if (typeof window !== "undefined") {
                    return window.innerWidth >= MOBILE_VIEWPORT_WIDTH;
                }
                return false;
            });

    useEffect(() => {
        setIsMounted(true);
    }, []);

    useEffect(() => {
        const win_resize = () => {
            setIsDesktop(window.innerWidth >= MOBILE_VIEWPORT_WIDTH);
        };
        window.addEventListener("resize", win_resize);
        win_resize();
        return () => window.removeEventListener("resize", win_resize);
    }, []);

    const pathName = usePathname();

    const tabRoutes = [
        {
            name: "ROI Calculator",
            href: "/admission/roi-calculator",
        },
        {
            name: "Scholarship Calculator",
            href: "/admission/scholarship-calculator",
        },
        {
            name: "Mode of Payment",
            href: "/admission/mode-of-payment",
        },
    ];

    if (!isMounted) return null;

    return (
        <div
            className={cn(
                /* `m-[0_auto] clear-both absolute left-1/2 transform -translate-x-1/2 top-full
                 mt-[-1.875rem] z-[1] max-w-full 
              ${isDropDown ? "md:w-auto md:p-0" : ""}
              xl:p-[0_5rem]`, */
                `md:w-auto md:p-0`,
                `w-full max-w-[90rem] m-[0_auto] p-[0_1.25rem] clear-both absolute left-1/2 transform -translate-x-1/2  top-full mt-[-1.875rem] z-[1]
        p-0 w-[calc(100%-2.5rem)] max-w-full`,

                ` before:bg-[url('/svgs/dot-black.svg')] before:absolute before:z-0 
   before:[background-size:0.1875rem] before:size-full before:inset-y-[-0.625rem] 
   before:opacity-0 before:transition-[opacity_0.5_cubic-bezier(0.22,0.61,0.36,1)]`,
                {
                    'before:opacity-[1]': isDropDown
                }
            )}
        >
            <button
                className={cn(
                    `text-[1rem] font-bold bg-white border border-[#272727] p-[0.625rem_2.5rem_0.625rem_1.25rem]
          min-h-[3.4375rem] w-full text-center relative cursor-pointer z-[1] rounded-[0] flex justify-center items-center`,
                    {
                        'before:absolute before:top-[1.015rem] before:right-[0.9375rem] before:transition-[transform_0.5s_cubic-bezier(0.22,0.61,0.36,1)]': !isDesktop,
                        'before:content-[url(/svgs/caretdown.svg)]': !isDesktop,
                        'before:transform before:rotate-z-180': isDropDown,
                        'md:hidden': isDesktop,
                    }
                )}
                onClick={() => setIsDropDown(pre => !pre)}
            >Why Pcps?</button>

            <nav
                /*  className={`${isDropDown ? "" : "bg-white border-[#272727] border-[1px] flex h-auto"
                   }
                w-full p-[0_1.25rem] overflow-hidden transition-[all_0.5s_cubic-bezier(0.22,0.61,0.36,1)] relative z-[1]
                `} */
                className={cn(
                    `bg-white border-[#272727] border w-full p-[0_1.25rem]
           overflow-hidden
           transition-[all_0.5s_cubic-bezier(0.22,0.61,0.36,1)] 
           relative z-[1]`,
                    {
                        'bg-white border-[#272727] border-[1px] flex h-auto': isDesktop,
                        'border-transparent': !isDesktop && !isDropDown,
                        'hidden': !isDesktop && !isDropDown,
                        'h-[218px]': isDropDown

                    }
                )}
            >
                {tabRoutes.map((tab) => (
                    <Link
                        href={tab.href}
                        key={tab.href.toLocaleLowerCase()}
                        /* className={`text-[#555555] text-sm 
                          leading-[4.375rem] [text-decoration:none] 
                          relative p-[0_2.3125rem] block whitespace-nowrap
                        ${pathName == tab.href
                            ? `after:absolute after:bottom-[-0.0625rem] 
                            after:w-full after:h-[0.375rem] after:bg-[#750102] after:left-0`
                            : ""
                          }
                        `} */
                        className={cn(
                            `text-sm 
              leading-[3.375rem] [text-decoration:none] 
              relative p-0 block 
              whitespace-nowrap border-b border-b-[rgba(39,39,39,0.25)]`,
                            {
                                'md:text-[0.875rem] md:leading-[4.375rem] md:[text-decoration:none] md:relative md:p-[0_2.3125rem] md:block md:[white-space:nowrap]': isDesktop,
                                'after:absolute after:bottom-[-0.0625rem] after:w-full after:h-[0.375rem] after:bg-[#750102] after:left-0 text-secondary-red font-semibold': pathName == tab.href && isDesktop,
                                'before:absolute before:top-1/2 before:transform before:-translate-y-1/2 before:bg-[#750102] before:w-[0.3125rem] before:h-[1.875rem] before:left-[-1.25rem]': pathName == tab.href && !isDesktop
                            }
                        )}
                    >
                        {tab.name}
                    </Link>
                ))}
            </nav>
        </div>
    );
};

export default AdmissionTab;
